import './Alert.scss';

import { Icon } from '@icarros/torque-react';
import classNames from 'classnames';
import React, { ReactNode } from 'react';

function WarningNotification({
  id,
  onClick,
  type,
  children,
  onClickClose
}: AlertProps): React.JSX.Element {
  return (
    <div
      id={id}
      onClick={onClick}
      onKeyDown={onClick}
      className={classNames('alert', {
        [`alert--${type}`]: type
      })}
      role="button"
      tabIndex={0}
    >
      {type === 'success' ? (
        <Icon name="check-circle" height="24px" width="24px" />
      ) : (
        <Icon name="warning-circle" height="24px" width="24px" />
      )}
      <span className="alert__text">{children}</span>
      <Icon className="alert__icon-close" name="close" onClick={onClickClose} />
    </div>
  );
}

type AlertProps = {
  id?: string;
  onClick?: () => void;
  type?: string;
  children?: ReactNode;
  onClickClose?: () => void;
};

export default WarningNotification;
